import {LeadhubIdentify} from 'utils/leadhub';
import * as yup from "yup";
import useUser from "grandus-lib/hooks/useUser";
import { Form, Button, Row, Col } from "antd";
import { useFormikContext, Formik } from "formik";
import { get, forEach, isFunction } from "lodash";

import TextInput from "grandus-lib/components-atomic/form/TextInput";
import PasswordInput from "grandus-lib/components-atomic/form/PasswordInput";
import useCart from "grandus-lib/hooks/useCart";
import SalesManago from "utils/salesmanago";

const Register = ({ afterRegisterCallback = null }) => {
  const { createUser } = useUser();
  const { cart } = useCart();
  const formProps = {
    enableReinitialize: true,
    initialValues: {
      firstname: "",
      surname: "",
      email: "",
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: yup.object({
      firstname: yup.string().nullable().trim().required("Povinné pole"),
      surname: yup.string().nullable().trim().required("Povinné pole"),
      email: yup
        .string()
        .nullable()
        .email("Zadajte email vo formáte name@domain.com")
        .required("Povinné pole"),
      password: yup
        .string()
        .min(6, "Heslo musí byť dlhšie ako 6 znakov.")
        .required("Povinné pole"),
      passwordRepeat: yup
        .string()
        .oneOf([yup.ref("password"), null], "Heslá sa nezhodujú")
        .required("Povinné pole"),
    }),
    onSubmit: async (values, { errors, setFieldError }) => {
      const userData = {
        user: {
          firstname: get(values, "firstname", ""),
          surname: get(values, "surname", ""),
          email: get(values, "email"),
          password: get(values, "password"),
          passwordRepeat: get(values, "passwordRepeat"),
        },
      };
      if (cart?.accessToken) {
        userData.cart = {
          accessToken: cart?.accessToken,
        };
      }

      await createUser(userData, (newUser) => {
        if (!get(newUser, "success", true)) {
          forEach(get(newUser, "data.messages", []), (res) => {
            setFieldError(get(res, "field"), get(res, "message"));
          });
        } else {
          LeadhubIdentify(newUser?.data,["registration"])
          if (isFunction(afterRegisterCallback)) {
            afterRegisterCallback(newUser);
          }
        }
        if (newUser?.data?.attributes) {
          SalesManago.contactUpsert({
            ...get(newUser, "data.attributes"),
            agreementAccepted: true,
          });
        }
      });

      return true;
    },
  };

  return (
    <Formik {...formProps}>
      <RegisterForm />
    </Formik>
  );
};

const RegisterForm = () => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormikContext();

  return (
    <Form wrapperCol={{ span: 24 }} layout="vertical" onFinish={handleSubmit}>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <TextInput
            label="Meno"
            name="firstname"
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Col>
        <Col xs={24} md={12}>
          <TextInput
            label="Priezvisko"
            name="surname"
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Col>
      </Row>
      <TextInput
        label="Email"
        name="email"
        values={values}
        touched={touched}
        errors={errors}
        handleChange={handleChange}
        handleBlur={handleBlur}
      />
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <PasswordInput
            label="Heslo"
            name="password"
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Col>
        <Col xs={24} md={12}>
          <PasswordInput
            label="Zopakujte heslo"
            name="passwordRepeat"
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          disabled={!isValid}
          loading={isValid && isSubmitting}
        >
          Registrovať
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Register;
